import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
import { useDebounce } from "stimulus-use"

// Connects to data-controller="ransack"
export default class extends Controller {
  static debounces = ['filter']

  connect() {
    useDebounce(this, { wait: 200 })
  }

  filter(event) {
    event.preventDefault();

    const form = this.element;
    const url = new URL(form.action);
    const formData = new FormData(form);

    get(url, {
      responseKind: 'turbo-stream',
      query: formData
    })
  }
}
